import { Badge, Button, Card, Col, ConfigProvider, Flex, Form, Input, Modal, Row, Skeleton, Space, Tabs } from "antd";
import { useForm } from "antd/es/form/Form";
import TabPane from "antd/es/tabs/TabPane";
import StatusTag from "components/elements/TagCustom/StatusTag";
import FormAntd from "components/form/FormProvide/FormAntd";
import dayjs from 'dayjs';
import { useTranslation } from "react-i18next";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/downloadIcon.svg";
import { useEffect } from "react";
import { CalculatorOutlined } from "@ant-design/icons";
const CalculationPage = ({
    PAYMENT_TAB = [],
    getTable = () => { },
    getVisibleIcon = () => { },
    searchTxt = "",
    onChange = () => { },
    onSearch = () => { },
    onClearSearchTxt = () => { },
    payrollPeriod = {},
    isLoading = false,
    isLoadingFile = false,
    onEditPayroll = () => { },
    onPageStatusChange = () => { },
    updateHeaderStatusToVerification = () => { },
    updateStatusToPending = () => { },
    totalEmployeeTab = {},
    pageStatus = '0',
    STATUS_TYPE = [],
    rowSelected = [],
    exportTxnPayment = () => { },
    onGroupCalculate = () => { },
    modelCalGroup = () => { }
}) => {
    const { t, i18n } = useTranslation()
    const [form] = useForm(null);
    const isSpecialPeriod = payrollPeriod?.specialPeriod == "Y"

    useEffect(() => {
        form.resetFields()
    }, [pageStatus, form])

    return (
        <>
            <Card style={{ backgroundColor: "#FCFCFC", borderRadius: "10px", border: "1px solid #D9D9D9", "height": "30vh", "width": "40vw" }}>
                {modelCalGroup()}
                {isLoading ? (
                    <Skeleton active={isLoading} />
                ) :
                    <Space direction='vertical' styles={{ "height": "20vh", "width": "30vw" }}>
                        <Row justify="space-between">
                            <span style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                {t("payment_period.label.period")} {dayjs(String(payrollPeriod?.month, "MM")).format('MMMM')} {isSpecialPeriod ? t("payment_period.label.special_period") : t("payment_period.label.period_no")} {payrollPeriod?.periodNo}
                            </span>
                            <StatusTag
                                value={payrollPeriod?.statusFlag}
                                text={(i18n.language === 'en' ? payrollPeriod?.statusNameEn : payrollPeriod?.statusName)}
                            />
                        </Row>
                        <Row style={{ gap: "32px" }}>
                            <Flex vertical>
                                <span style={{ color: "#42526D" }}>{t("payroll.employment_type_setup.header")}</span>
                                {payrollPeriod?.employmentType?.map((o) => (
                                    <span key={o?.id} style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                        {i18n.language === 'en' ? o?.employmentTypeNameEn : o?.employmentTypeName}
                                    </span>
                                ))}
                            </Flex>
                            <Flex vertical>
                                <span style={{ color: "#42526D" }}>{t("payroll.payroll_period")}</span>
                                <span style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                    {i18n.language === "en"
                                        ? (dayjs(payrollPeriod?.startPeriod).format("DD/MM/YYYY") + " - " + dayjs(payrollPeriod?.endPeriod).format("DD/MM/YYYY"))
                                        : (dayjs(payrollPeriod?.startPeriod).format("DD/MM/BBBB") + " - " + dayjs(payrollPeriod?.endPeriod).format("DD/MM/BBBB"))}
                                </span>
                            </Flex>

                            <Flex vertical>
                                <span style={{ color: "#42526D" }}>{t("payment_period.label.payment_date")}</span>

                                <Flex gap={8}>
                                    <span style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                        {i18n.language === "en"
                                            ? dayjs(payrollPeriod?.paymentDate).format("DD/MM/YYYY")
                                            : dayjs(payrollPeriod?.paymentDate).format("DD/MM/BBBB")}
                                    </span>
                                    {payrollPeriod?.step === 0 && (
                                        <EditIcon style={{ fontSize: "16px", padding: 0, alignSelf: "center", cursor: "pointer" }} onClick={() => onEditPayroll()} />
                                    )}
                                </Flex>

                            </Flex>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Flex justify="space-between">
                                    <Flex vertical>
                                        <span style={{ color: "#42526D" }}>{t('payment.label.numberOfEmployee')}</span>
                                        <span style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                            {payrollPeriod?.numberOfEmployee ?? 0 + " " + t("expense.expense-detail.person")}
                                        </span>
                                    </Flex>
                                    <Flex vertical>
                                        <span style={{ color: "#42526D" }}>{t('payment.label.total')}</span>
                                        <span style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                            {get2DecimalPointsWithCommas(payrollPeriod?.netIncome) + " " + t('unit.baht')}
                                        </span>
                                    </Flex>

                                </Flex>

                            </Col>
                        </Row>
                    </Space>
                }
            </Card>

            <ConfigProvider
                theme={{
                    components: {
                        Tabs: {
                            itemHoverColor: "var(--tab-color)",
                            itemActiveColor: "var(--tab-color)"
                        },
                    },
                }}
            >
                <Tabs
                    onChange={(e) => onPageStatusChange(e)}
                    tabBarStyle={{ justifyContent: 'space-between' }}
                >
                    {STATUS_TYPE.map(tab => (
                        <TabPane
                            key={tab.key}
                            tab={
                                <Flex gap={8}>
                                    <span>{i18n.language === 'en' ? tab?.nameEn : tab?.name}</span>
                                    <Badge count={tab?.values} showZero />
                                </Flex>
                            }
                        />
                    ))}
                </Tabs>

            </ConfigProvider>
            <Row>
                <Col span={24}>
                    <Tabs
                        onChange={onChange}
                        tabBarStyle={{ justifyContent: 'space-between' }}
                    >
                        {
                            pageStatus === '0' ? PAYMENT_TAB?.map((tab) => (
                                <TabPane
                                    key={tab.key}
                                    tab={
                                        <Flex gap={8}>
                                            <span>{tab.label}</span>
                                            {['editedItems'].includes(tab?.key) ? null : (
                                                <Badge count={tab?.values} showZero />
                                            )}
                                        </Flex>
                                    }
                                />
                            )) : null
                        }
                    </Tabs>

                    <Flex justify="space-between">
                        <Flex justify="start">
                            <FormAntd
                                form={form}
                                initialValues={{ searchTxt }}
                                onFinish={onSearch}
                            >
                                <Form.Item name="searchTxt" style={{ "width": "40vw" }} >
                                    <Flex gap={10} >
                                        <Input
                                            name="searchTxt"
                                            placeholder={i18n.language === 'en' ? "employee no / name / nameEn / surname / surnameEn" : "รหัสพนักงาน / ชื่อ / นามสกุล / ชื่อภาษาอังกฤษ / นามสกุลภาษาอังกฤษ"}
                                            style={{ "height": "5vh", width: "30vw" }}
                                        />
                                        <Button
                                            // loading={isLoading}
                                            type="default"
                                            onClick={onClearSearchTxt}
                                            style={{ borderRadius: 8, "height": "5vh", "width": "6vw" }}
                                        >
                                            {t("common.clear").toUpperCase()}
                                        </Button>
                                        <Button
                                            title="1"
                                            // loading={isLoading}
                                            type="primary"
                                            htmlType="submit"
                                            style={{ height: "5vh", width: "6vw", borderRadius: 8, backgroundColor: "var(--button-color)", }}
                                        >
                                            {/* <Flex justify="space-between"> */}
                                            {t("creatTamplete.Search").toUpperCase()}
                                            {/* </Flex> */}
                                        </Button>
                                    </Flex>
                                </Form.Item>
                            </FormAntd>
                        </Flex>

                        <Flex justify="end" gap={10}>
                            {/* <Button
                                type="default"
                                style={{ padding: "8px 16px", height: 44, borderRadius: 8 }}
                            >
                                <Flex align="center" justify="center" gap={8}>
                                    <FilterIcon />
                                    <span style={{ color: "#667085" }}>{t('common.filter')}</span>
                                </Flex>
                            </Button> */}
                            {payrollPeriod?.step == 0 ?
                                <Flex justify="space-between">
                                    <Button
                                        type="default"
                                        style={{ padding: "8px 16px", height: 44, borderRadius: 8 }}
                                        // onClick={exportTxnPayment}
                                        onClick={() => {
                                            Modal.confirm({
                                                title: t("dialog.confirmation.header"),
                                                content: i18n.language === 'en' ? "Confirm download of employee salary report?" : "ยืนยันการดาวน์โหลดรายงานเงินเดือนพนักงานหรือไม่",
                                                onOk() {
                                                    exportTxnPayment();
                                                },
                                                okText: t("common.confirm"),
                                                cancelText: t("common.cancel"),
                                            });
                                        }                                          // confirmModalFn(exportTxnPayment, MESSAGE.DOWNLOAD_EMPLOYEE_SALARY_REPORT)
                                        }
                                    >
                                        <Flex align="center" justify="center" gap={8}>
                                            <DownloadIcon />
                                            <span style={{ color: "#667085" }}>{t('payment.label.download.report')}</span>
                                        </Flex>
                                    </Button>
                                    <Button
                                        type="default"
                                        style={{ padding: "8px 16px", height: 44, borderRadius: 8 }}
                                        // onClick={exportTxnPayment}
                                        // loading={isLoadingFile}
                                        disabled={isLoadingFile}
                                        onClick={() => {
                                            // console.log("group calculation")
                                            onGroupCalculate()
                                        }}
                                    >
                                        <Flex align="center" justify="center" gap={8}>
                                            <CalculatorOutlined />
                                            <span style={{ color: "#667085" }}>{t('payment.label.group_calculation')}</span>
                                        </Flex>
                                    </Button>
                                </Flex>
                                : null
                            }
                            {getVisibleIcon()}
                        </Flex>
                    </Flex>

                    <Row>
                        <Col span={24}>{getTable()}</Col>
                    </Row>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    {payrollPeriod?.step == 0 ? <Flex justify="end" gap={"10px"}>
                        {
                            pageStatus === '2' ?
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    disabled={totalEmployeeTab?.countIncomplete > 0 && payrollPeriod?.step !== 0 || rowSelected?.length === 0}
                                    onClick={() => {
                                        Modal.confirm({
                                            title: t("dialog.confirmation.header"),
                                            content: (
                                                <>
                                                    <p>
                                                        {t('payment.label.returnToCalculation')}
                                                    </p>
                                                </>
                                            ),
                                            onOk() {
                                                updateStatusToPending()
                                            },
                                            okText: t("common.confirm").toUpperCase(),
                                            cancelText: t("common.cancel").toUpperCase(),
                                        });
                                    }}
                                    style={{ borderRadius: "8px", height: "40px", backgroundColor: totalEmployeeTab?.countIncomplete > 0 ? "" : "var(--button-color)" }}
                                >
                                    {t('payment.label.returnToCalculation')}
                                </Button> : null
                        }
                        {
                            pageStatus === '1' ?

                                <Flex gap={'5px'}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        disabled={totalEmployeeTab?.countIncomplete > 0 && payrollPeriod?.step !== 0 || rowSelected?.length === 0}
                                        onClick={() => {
                                            Modal.confirm({
                                                title: t("dialog.confirmation.header"),
                                                content: (
                                                    <>
                                                        <p>
                                                            {t('payment.label.returnToCalculation')}
                                                        </p>
                                                    </>
                                                ),
                                                onOk() {
                                                    updateStatusToPending()
                                                },
                                                okText: t("common.confirm").toUpperCase(),
                                                cancelText: t("common.cancel").toUpperCase(),
                                            });
                                        }}
                                        style={{ borderRadius: "8px", height: "40px", backgroundColor: totalEmployeeTab?.countIncomplete > 0 ? "" : "var(--button-color)" }}
                                    >
                                        {t('payment.label.returnToCalculation')}
                                    </Button>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        disabled={totalEmployeeTab?.countIncomplete > 0 && payrollPeriod?.step !== 0 && rowSelected?.length === 0}
                                        onClick={() => {
                                            Modal.confirm({
                                                title: t("dialog.confirmation.header"),
                                                content: (
                                                    <>
                                                        <p>
                                                            {t("payment.label.verify-salary")}
                                                        </p>
                                                    </>
                                                ),
                                                onOk() {
                                                    updateHeaderStatusToVerification()
                                                },
                                                okText: t("common.confirm").toUpperCase(),
                                                cancelText: t("common.cancel").toUpperCase(),
                                            });
                                        }}
                                        style={{ borderRadius: "8px", height: "40px", backgroundColor: totalEmployeeTab?.countIncomplete > 0 ? "" : "var(--button-color)" }}
                                    >
                                        {t("payment.label.verify-salary")}
                                    </Button>

                                </Flex> : null
                        }

                    </Flex> : null}

                </Col>
            </Row>
        </>
    )
}

export default CalculationPage